import {InfoCircleOutlined} from '@ant-design/icons';
import {Col, Form, Input, Select} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import moment from 'moment';
import React from 'react';
import {useSearchParams} from 'react-router-dom';

import {ReactComponent as YearCalender} from '../../assets/yearCalender.svg';
import {CommonErrors} from '../../constants/Common';
import InformativeText from '../../constants/InformativeText';
import NumberInput from '../../shared/NumberInput';
import useCompanyStore from '../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../store/StaticJson/jsonStore';
import {eachWordCap, FirstCap} from '../../utils/FormUtils/FirstCap';
import RegEx from '../../utils/FormUtils/RegEx';
import {yearSelect} from '../../utils/FormUtils/yearSelect';
import PhoneNumberInput from '../CustomInputs/PhoneNumberInput/PhoneNumberInput';
import SelectWithOtherOption from '../CustomInputs/Select/SelectWithOtherOption';
import MomentDatePicker from '../DatePicker/MomentDatePicker';

import {yearKeyLabel} from './Constants/IP/commonKeyLabel';
import {
  downPropertyKey,
  downPropertyLabel
} from './Constants/IP/dSPropertyKeyLabel';
import UserCreationToggle from './UserCreationToggle/UserCreationToggle';
import {filterSelectOptions} from './Utils/commonFunctions';

const DownPropertyForm: React.FC<{
  data?: Record<string, unknown>;
  currentStep?: number;
}> = ({data, currentStep}) => {
  const FormInstance = useFormInstance();
  const yearFilter = yearSelect();
  const [searchParam] = useSearchParams();
  const companyUnits = useCompanyStore.getState().preUnits;

  const {setFields, getFieldValue} = FormInstance;

  const propertyType = useJSONStore.getState().propertyType;

  const assetInfo = InformativeText?.AM;

  return (
    <>
      {currentStep === 0 && (
        <>
          {/* <Col className="gutter-row" span={colSpan}> */}
          <Col className="gutter-row">
            <Form.Item
              name={yearKeyLabel.key}
              label={yearKeyLabel.label}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(yearKeyLabel.label)
                }
              ]}
              initialValue={searchParam.get('selectedYear')}
            >
              <Select
                placeholder={yearKeyLabel.label}
                options={yearFilter}
                suffixIcon={<YearCalender />}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name={downPropertyKey.ASSET_NAME}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(downPropertyLabel.ASSET_NAME)
                },
                {
                  max: 100,
                  message: `${downPropertyLabel.ASSET_NAME} should be less than 100 characters`
                },
                {
                  min: 3,
                  message: `${downPropertyLabel.ASSET_NAME} should be more than 2 characters`
                },
                {
                  pattern: RegEx.fullName,
                  message: CommonErrors.noSpecialChar
                },
                {
                  whitespace: true,
                  message: CommonErrors.mandatory(downPropertyLabel.ASSET_NAME)
                }
              ]}
              label={downPropertyLabel.ASSET_NAME}
              labelCol={{span: 24}}
              initialValue={''}
              tooltip={{
                icon: <InfoCircleOutlined />,
                title: assetInfo?.assetName
              }}
              validateFirst={true}
              hasFeedback
            >
              <Input
                className="input"
                placeholder={`Enter ${downPropertyLabel.ASSET_NAME}`}
                onInput={(e) => {
                  const target = e.target as HTMLInputElement;
                  target.value = eachWordCap(target.value);
                }}
              />
            </Form.Item>
          </Col>
          <UserCreationToggle
            existingEmail={data?.[downPropertyKey.ASSET_EMAIL] as string}
            label={downPropertyLabel.IS_USER_CREATION}
            dependentFields={[
              downPropertyKey.FIRST_NAME,
              downPropertyKey.LAST_NAME,
              downPropertyKey.ASSET_MOBILE,
              downPropertyKey.ASSET_EMAIL
            ]}
          >
            <Col className="gutter-row">
              <Form.Item
                name={downPropertyKey.FIRST_NAME}
                label={downPropertyLabel.FIRST_NAME}
                labelCol={{span: 24}}
                rules={[
                  {
                    required: true,
                    message: CommonErrors.mandatory(
                      downPropertyLabel.FIRST_NAME
                    )
                  },
                  {
                    max: 100,
                    message: `${downPropertyLabel.FIRST_NAME} Should not be more than 100 Characters`
                  },
                  {
                    min: 2,
                    message: `${downPropertyLabel.FIRST_NAME} Should be more than 1 Characters`
                  },
                  {
                    pattern: RegEx.names,
                    message:
                      'No special characters , Empty spaces or Numbers are Allowed'
                  }
                ]}
                validateFirst={true}
                hasFeedback
              >
                <Input
                  onInput={(e) => {
                    const target = e.target as HTMLInputElement;
                    target.value = FirstCap(target.value);
                  }}
                  placeholder={`Enter ${downPropertyLabel.FIRST_NAME}`}
                />
              </Form.Item>
            </Col>
            <Col className="gutter-row">
              <Form.Item
                name={downPropertyKey.LAST_NAME}
                label={downPropertyLabel.LAST_NAME}
                labelCol={{span: 24}}
                rules={[
                  {
                    required: true,
                    message: CommonErrors.mandatory(downPropertyLabel.LAST_NAME)
                  },
                  {
                    max: 100,
                    message: `${downPropertyLabel.LAST_NAME} Should not be more than 100 Characters`
                  },
                  {
                    min: 2,
                    message: `${downPropertyLabel.LAST_NAME} Should be more than 1 Characters`
                  },
                  {
                    pattern: RegEx.names,
                    message:
                      'No special characters , Empty spaces or Numbers are Allowed'
                  }
                ]}
                validateFirst={true}
                hasFeedback
              >
                <Input
                  onInput={(e) => {
                    const target = e.target as HTMLInputElement;
                    target.value = FirstCap(target.value);
                  }}
                  placeholder={`Enter ${downPropertyLabel.LAST_NAME}`}
                />
              </Form.Item>
            </Col>
            {/* <Col className="gutter-row" span={colSpan}> */}
            <Col className="gutter-row">
              <Form.Item
                name={downPropertyKey.ASSET_MOBILE}
                rules={[
                  {
                    required: true,
                    message: CommonErrors.mandatory(
                      downPropertyLabel.ASSET_MOBILE
                    )
                  }
                  // {
                  //   // eslint-disable-next-line @typescript-eslint/promise-function-async
                  //   validator(_, value) {
                  //     if (RegEx.mobile.test(value)) {
                  //       return Promise.resolve();
                  //     } else {
                  //       return Promise.reject(
                  //         new Error(
                  //           CommonErrors.validField(
                  //             downPropertyLabel.ASSET_MOBILE
                  //           )
                  //         )
                  //       );
                  //     }
                  //   }
                  // }
                ]}
                label={downPropertyLabel.ASSET_MOBILE}
                validateFirst={true}
                hasFeedback
                labelCol={{span: 24}}
              >
                <PhoneNumberInput />
              </Form.Item>
            </Col>
            {/* <Col className="gutter-row" span={colSpan}> */}
            <Col className="gutter-row">
              <Form.Item
                name={downPropertyKey.ASSET_EMAIL}
                label={downPropertyLabel.ASSET_EMAIL}
                labelCol={{span: 24}}
                rules={[
                  {
                    required: true,
                    message: CommonErrors.mandatory(
                      downPropertyLabel.ASSET_EMAIL
                    )
                  },
                  {
                    min: 5,
                    message: `${downPropertyLabel.ASSET_EMAIL} Should be more than 4 Characters`
                  },
                  {
                    max: 320,
                    message: `${downPropertyLabel.ASSET_EMAIL} Should not be more than 320 Characters`
                  },
                  {
                    pattern: RegEx.email,
                    message: CommonErrors.validField(
                      downPropertyLabel.ASSET_EMAIL
                    )
                  }
                ]}
                validateFirst={true}
                hasFeedback
              >
                <Input placeholder={`Enter ${downPropertyLabel.ASSET_EMAIL}`} />
              </Form.Item>
            </Col>
          </UserCreationToggle>
          {/* <Col className="gutter-row" span={colSpan}> */}
          <Col className="gutter-row">
            <Form.Item
              name={downPropertyKey.PROPERTY_TYPE}
              // rules={[
              //   {
              //     required: true,
              //     message: CommonErrors.mandatory(
              //       downPropertyLabel.PROPERTY_TYPE
              //     )
              //   }
              // ]}
              label={downPropertyLabel.PROPERTY_TYPE}
              labelCol={{span: 24}}
              validateFirst={true}
              hasFeedback
            >
              <SelectWithOtherOption
                className="input"
                showSearch
                placeholder={`Choose ${downPropertyLabel.PROPERTY_TYPE}`}
                options={propertyType}
                allowClear
                filterOption={filterSelectOptions}
              />
            </Form.Item>
          </Col>
          {/* <Col className="gutter-row" span={colSpan}> */}
          <Col className="gutter-row">
            <Form.Item
              name={downPropertyKey.FLOOR_SPACE}
              label={downPropertyLabel.FLOOR_SPACE}
              labelCol={{span: 24}}
              initialValue={undefined}
              rules={[
                // {
                //   required: true,
                //   message: CommonErrors.mandatory(downPropertyLabel.FLOOR_SPACE)
                // },
                {
                  pattern: RegEx.twoDigitDecimal,
                  message: CommonErrors.twoDigitPositive
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <NumberInput
                addonAfter={companyUnits.area}
                className="input"
                placeholder={`Enter ${downPropertyLabel.FLOOR_SPACE}`}
              />
            </Form.Item>
          </Col>
          {/* <Col className="gutter-row" span={colSpan}> */}
          <Col className="gutter-row">
            <Form.Item
              name={downPropertyKey.RENTED_FROM}
              label={downPropertyLabel.RENTED_FROM}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(downPropertyLabel.RENTED_FROM)
                }
              ]}
              validateFirst={true}
              hasFeedback
              labelCol={{span: 24}}
            >
              <MomentDatePicker
                disabledDate={(current: any) => {
                  return moment() <= current || moment('1900/04') > current;
                }}
                inputReadOnly
                format="DD-MM-YYYY"
                style={{width: '100%'}}
                showNow={false}
                onChange={() => {
                  if (getFieldValue(downPropertyKey.RENTED_TO)) {
                    setFields([
                      {
                        name: downPropertyKey.RENTED_TO,
                        errors: [CommonErrors.selectAgain],
                        value: undefined
                      }
                    ]);
                  }
                }}
              />
            </Form.Item>
          </Col>
          {/* <Col className="gutter-row" span={colSpan}> */}
          <Col className="gutter-row">
            <Form.Item dependencies={[downPropertyKey.RENTED_FROM]}>
              {({getFieldValue}) => (
                <Form.Item
                  name={downPropertyKey.RENTED_TO}
                  label={downPropertyLabel.RENTED_TO}
                  shouldUpdate={true}
                  rules={[
                    {
                      required: true,
                      message: CommonErrors.mandatory(
                        downPropertyLabel.RENTED_TO
                      )
                    }
                  ]}
                  validateFirst={true}
                  hasFeedback
                  labelCol={{span: 24}}
                >
                  <MomentDatePicker
                    disabledDate={(current: any) => {
                      return (
                        getFieldValue(downPropertyKey.RENTED_FROM) > current
                      );
                    }}
                    inputReadOnly
                    format="DD-MM-YYYY"
                    style={{width: '100%'}}
                    showNow={false}
                    disabled={!getFieldValue(downPropertyKey.RENTED_FROM)}
                  />
                </Form.Item>
              )}
            </Form.Item>
          </Col>
        </>
      )}
    </>
  );
};

export default DownPropertyForm;
